import { UsersActionTypes, UsersActions } from '@modules/super-admin/actions/users.actions';
import { UserDetailInterface } from '@interfaces/user-detail.interface';

export interface State {
    users: UserDetailInterface[];
    getAllUserDataPending: boolean;
    getAllUserDataError: String | boolean;
    getAllUserDataSuccess: boolean;
}

export const initialState: State = {
    users: [],
    getAllUserDataPending: true,
    getAllUserDataError: false,
    getAllUserDataSuccess: false
};

export function reducer(state = initialState, action: UsersActions) {
    switch (action.type) {
        case UsersActionTypes.GetAllUsers:
            return {
                ...state,
                getAllUserDataPending: true,
                getAllUserDataError: false,
                getAllUserDataSuccess: false
            };

        case UsersActionTypes.GetAllUsersSuccess:
            return {
                ...state,
                users: action.payload,
                getAllUserDataPending: false,
                getAllUserDataError: false,
                getAllUserDataSuccess: true
            };

        case UsersActionTypes.GetAllUsersFailure:
            return {
                ...state,
                getAllUserDataPending: false,
                getAllUserDataError: action.payload,
                getAllUserDataSuccess: false
            };

        default:
            return state;
    }
}

export const getUsers = (state: State) => state.users;
export const getUsersPending = (state: State) => state.getAllUserDataPending;
export const getUsersSuccess = (state: State) => state.getAllUserDataSuccess;
export const getUsersError = (state: State) => state.getAllUserDataError;
